import { render, staticRenderFns } from "./AutoSacrificeAdvancedTab.vue?vue&type=template&id=41be01c5&scoped=true&"
import script from "./AutoSacrificeAdvancedTab.vue?vue&type=script&lang=js&"
export * from "./AutoSacrificeAdvancedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41be01c5",
  null
  
)

export default component.exports